export const ZOOM_MIN = 0.5
export const ZOOM_MAX = 4
export const ZOOM_FACTOR = 1.25
